import { cx, styled } from "simplydo/react/styled";

import { Divider } from "../divider";

type MessageActionsProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const ActionsEl = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const MessageActionsComponent = ({
  children,
  className,
  style,
}: MessageActionsProps) => {
  return (
    <>
      <Divider />
      <ActionsEl className={cx(className)} style={style}>
        {children}
      </ActionsEl>
    </>
  );
};

export const MessageActions = styled(MessageActionsComponent)``;
